import { m, LazyMotion, domAnimation, Variants, AnimationProps } from 'framer-motion'

import styles from './index.module.scss'

type TimelineData = {
  year?: string
  description?: string
  textAnimate: AnimationProps['animate']
  lineAnimate: AnimationProps['animate']
}

const ITEM_VARIANTS: Variants = {
  start: { opacity: 0 },
  end: { opacity: 1, transition: { type: 'spring', bounce: 0, delay: 0.5 } },
}

const LINE_VARIANTS: Variants = {
  start: { height: '0%' },
  end: { height: '100%', transition: { duration: 1 } },
}

export const TimelineItem = ({ year, description, textAnimate, lineAnimate }: TimelineData) => {
  return (
    <LazyMotion features={domAnimation} strict>
      <m.div
        className={styles['timeline-wrapper']}
        animate={textAnimate}
        variants={ITEM_VARIANTS}
        initial="start"
      >
        <div className={styles['thread']}>
          <span className={styles['dot']} />
          <m.hr
            className={styles['vertical-line']}
            animate={lineAnimate}
            initial="start"
            variants={LINE_VARIANTS}
          />
        </div>
        <div className={styles['content']}>
          <p className={styles['year']}>{year}</p>
          <p className={styles['description']}>{description}</p>
        </div>
      </m.div>
    </LazyMotion>
  )
}

export default TimelineItem
